import { Flex, Grid, Skeleton } from '@chakra-ui/react';

export const NabanDeedLoading = () => {
  return (
    <Flex flexDirection='column' gap={8} w='full'>
      <Skeleton height='3rem' width='24rem' />
      <Grid gridTemplateColumns={{ base: '1fr', md: '3fr 1fr' }} gap={8} alignItems='start'>
        <Flex flexDirection='column' gap={8}>
          <Skeleton h='15rem' w='full' />
          <Skeleton h='15rem' w='full' />
          <Skeleton h='15rem' w='full' />
        </Flex>
        <Skeleton h='60rem' w='full' />
      </Grid>
    </Flex>
  );
};
